import "./ImageZoom.css";

const ImageZoom = ({ src, alt, width, height, onClick }) => {
  return (
    <div
      className="image-zoom-container"
      style={{ width: width, height: height }}
    >
      <img
        src={src}
        alt={alt}
        className="image-zoom-img"
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : undefined }}
      />
    </div>
  );
};

export default ImageZoom;
